import { Button, ToggleGroup, ToggleGroupItem } from '@monksflow/monks-ui';
import { CircleIcon, SquareIcon, XIcon } from 'lucide-react';
import GestureIcon from '@/shared/assets/images/Gesture.svg';
import { ImageEditorProps, type EditTool } from './ImageEditor.types';
import { useTranslation } from 'react-i18next';

export default function ImageEditor({ tool, setTool, onClear, onClose }: ImageEditorProps) {
  const { t } = useTranslation('contentTest');

  return (
    <div className="grid w-full grid-cols-[1fr_auto_1fr] items-center gap-2 pr-9">
      <span className="justify-self-start text-body-lg font-medium text-foreground">
        {t('imageWidget.imageEditor.editSelection')}
      </span>
      <div className="flex justify-self-center gap-1.5">
        <ToggleGroup
          type="single"
          variant="outline"
          spacing={1.5}
          value={tool}
          // Radix lets a single-value group be deselected; the canvas always
          // needs a tool, so an empty value keeps the current one.
          onValueChange={(next) => next && setTool(next as EditTool)}
        >
          {/* eslint-disable-next-line i18next/no-literal-string -- tool identifier, not copy */}
          <ToggleGroupItem value="rect" aria-label={t('imageWidget.imageEditor.rectangle')}>
            <SquareIcon />
          </ToggleGroupItem>
          {/* eslint-disable-next-line i18next/no-literal-string -- tool identifier, not copy */}
          <ToggleGroupItem value="circle" aria-label={t('imageWidget.imageEditor.circle')}>
            <CircleIcon />
          </ToggleGroupItem>
          {/* eslint-disable-next-line i18next/no-literal-string -- tool identifier, not copy */}
          <ToggleGroupItem value="brush" aria-label={t('imageWidget.imageEditor.freeDraw')}>
            <img
              src={GestureIcon}
              alt={t('imageWidget.imageEditor.gesture')}
              className="h-6 w-9.5"
            />
          </ToggleGroupItem>
        </ToggleGroup>
        <Button variant="outline" size="sm" onClick={onClear}>
          {t('imageWidget.imageEditor.clear')}
        </Button>
      </div>
      <Button
        variant="ghost"
        size="icon-sm"
        onClick={onClose}
        className="justify-self-end"
        aria-label={t('imageWidget.imageEditor.close')}
      >
        <XIcon />
      </Button>
    </div>
  );
}
